export default "__VITE_ASSET__Bzvqb6QT__"